<template>
    <div    class="w-full flex justify-around">
        <div    class="w-1/3">
            <h3>Export Users</h3>
            <p>
                Select the company to export users from.  Any users existing on it and it's children that
                you can view will be exported.  As part of that export, the highest permission level will be listed.
            </p>

            <!-- Company -->
            <div    class="flex items-center">
                <label  class="mr-2"
                        for="company_id">Company
                </label>
                <select2    id="company_id"
                            v-model:value="companyId"
                            :options="companies"
                            name="company_id"
                ></select2>
            </div>

            <!-- Button to save -->
            <button-blue-primary    class="w-full my-2"
                                    @click="handleExportUsers">
                <div    v-if="exportingUsers"
                        class="flex items-center">
                    <div    :class="iconLoading"></div>
                    <div>Exporting ...</div>
                </div>
                <div    v-else>
                    Export Users
                </div>
            </button-blue-primary>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import UndecoratedLink from "@/components/EnterpriseDashboard/undecorated-link.vue";
import Select2 from "@/components/elements/select2.vue";
import ButtonBluePrimary from "@/components/elements/buttons/ButtonBluePrimary.vue";

export default {
    name: "ExportUsersIndex",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {ButtonBluePrimary, Select2},
    emits: [],
    props: {
        companies: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            companyId: null,
            exportingUsers: false,
        }
    },
    created() {

    },
    mounted() {
    },
    methods: {
        handleExportUsers() {
            if (this.exportingUsers) {
                return;
            }

            this.exportingUsers = true;
            axios.post('api-internal/export-users', {
                company_id: this.companyId,
            }).catch(error => {
                console.log(error);
            }).then(response => {
                this.exportingUsers = false;
                console.log(response);
            });
        },
    },
    computed: {},
    watch: {},
}
</script>

<style scoped>

</style>